'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/antd/lib/input-number/style/index.js
// module id = 1564
// module chunks = 0